import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { cancel, save, update } from '../state/actions.tsx';
import {
	getBaseUrl,
	getProjectDefaultAssignee,
	getProjectLeadName,
	isSaving,
	canSubmit,
	getName,
	getDescription,
	getLead,
	getDefaultAssignee,
	getNameErrorMessage,
} from '../state/selectors.tsx';
import type { State } from '../state/types.tsx';
import CreateModal, { type Props } from './view.tsx';

type StateProps = Pick<
	Props,
	| 'baseUrl'
	| 'isSaving'
	| 'canSubmit'
	| 'projectDefaultAssignee'
	| 'projectLeadName'
	| 'name'
	| 'description'
	| 'lead'
	| 'defaultAssignee'
	| 'nameErrorMessage'
>;

const mapStateToProps = (state: State): StateProps => ({
	baseUrl: getBaseUrl(state),
	isSaving: isSaving(state),
	canSubmit: canSubmit(state),
	projectDefaultAssignee: getProjectDefaultAssignee(state),
	projectLeadName: getProjectLeadName(state),
	name: getName(state),
	description: getDescription(state),
	lead: getLead(state),
	defaultAssignee: getDefaultAssignee(state),
	nameErrorMessage: getNameErrorMessage(state),
});

type DispatchProps = Pick<Props, 'onCancel' | 'onConfirm' | 'onUpdateComponent'>;

const mapDispatchToProps: DispatchProps = {
	onCancel: cancel,
	onConfirm: save,
	onUpdateComponent: update,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateModal);
